import fetch from '@/utils/fetch'

export function getImageList(params) {
  return fetch({
    url: '/espier/images',
    method: 'get',
    params
  })
}

// 新增圖片分組
export function addImageCatgory(params) {
  return fetch({
    url: '/espier/image/cat',
    method: 'post',
    params
  })
}

// 獲取圖片分組
export function getImageAllCatgory(params) {
  return fetch({
    url: `/espier/image/cat/children`,
    method: 'get',
    params
  })
}

// 刪除圖片分組
export function deleteImageGroup(image_cat_id) {
  return fetch({
    url: `/espier/image/cat/${image_cat_id}`,
    method: 'delete'
  })
}

// 移動圖片分組
export function moveImageGroup(params) {
  return fetch({
    url: '/espier/image/movecat',
    method: 'post',
    params
  })
}
